import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export default class MarketPerformanceDataItemSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/data-item');
    }

    if (key === 'kpis') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/kpi');
    }

    if (key === 'subscriptions') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/subscription');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // `kpis` is keyed by metric type ({ otb: { totals } }): fold the key into the
  // id so it loads as KPI records. The previous KPIs are unloaded first, so a
  // metric type missing from this response can't keep stale values.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeQueryResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: Record<string, unknown>,
    id: string | null,
    requestType: string,
  ) {
    const kpis = payload['kpis'] as Record<string, object> | undefined;
    const data = payload['data'] as
      | { metric_type: string; pickup_days?: number }[]
      | undefined;

    // Pickup rows share their base row's metric type: key them the way
    // `meta.totals` and `kpis` already do (`otb:pickup:1`).
    if (data) {
      payload['data'] = data.map((item) =>
        item.pickup_days
          ? {
              ...item,
              metric_type: `${item.metric_type}:pickup:${item.pickup_days}`,
            }
          : item,
      );
    }

    store.unloadAll('market-performance/kpi');

    if (kpis) {
      payload['kpis'] = Object.entries(kpis).map(([metricType, kpi]) => ({
        ...kpi,
        id: metricType,
      }));
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalizeQueryResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }
}
